import React from 'react'
import { Route, Redirect, RouteProps } from 'react-router-dom'
import * as H from 'history'
import Authorized from './Authorized'
import { Authority } from './typings.d'

type Props = RouteProps & {
  authority: Authority
  redirectTo: H.LocationDescriptor
}

const AuthorizedRoute: React.FC<Props> = ({
  component: Component,
  render = () => null,
  authority,
  redirectTo,
  ...rest
}: Props): JSX.Element => (
  <Authorized
    authority={authority}
    noMatch={<Route {...rest} render={() => <Redirect to={redirectTo} />} />}
  >
    <Route {...rest} render={props => (Component ? <Component {...props} /> : render(props))} />
  </Authorized>
)

export default AuthorizedRoute
